/*
Controller: FeatureAgreements

Operations:
  getFeatureAgreements
*/
var Api = require('../config')

var FeatureAgreements = (function () {
  /*
  Operation: getFeatureAgreements
  Get feature agreements
  Parameters:
    featureAgreementType: Feature agreements type
  Responses:
    HTTP 200: Successful operation
    HTTP 400: Invalid payload
    HTTP 500: Server error
  */
  function getFeatureAgreementsFeatureAgreements (featureAgreementType) {
    return new Promise(function (resolve, reject) {
      try {
        if (!featureAgreementType) {
          throw new Error('featureAgreementType: Missing parameter')
        }
        if (featureAgreementType && !(typeof featureAgreementType === 'string')) {
          throw new Error('featureAgreementType: Wrong type: Got "' + (typeof featureAgreementType) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/featureAgreements/{featureAgreementType}'
      path = path.replace('{' + 'featureAgreementType' + '}', featureAgreementType)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getFeatureAgreements'] = getFeatureAgreementsFeatureAgreements
  return ret
})()

module.exports = FeatureAgreements
